import { Subtitle } from '@tremor/react';
import { WorkspacesTable } from '../Tables/WorkspacesTable/WorkspacesTable';
import { useEffect, useMemo, useState } from 'react';
import { find, map } from 'lodash';
import { ConfirmDeletionModal } from '../layouts/Modals/ConfirmDeletionModal/ConfirmDeletionModal';
import { WorkspaceFromStore } from '@/types/workspaces';
import { useFetcherWithUtils } from '@/hooks/useFetcherWithUtils';
import { FetcherMultiErrorResponse } from '@/types/types';
import s from './OrganizationWorkspacesManagement.module.scss';

type Props = {
  organizationWorkspaces: WorkspaceFromStore[];
};

export function OrganizationWorkspacesManagement({ organizationWorkspaces }: Props) {
  const [isConfirmDeletionModalOpen, setIsConfirmDeletionModalOpen] = useState(false);
  const [workspace, setWorkspace] = useState<WorkspaceFromStore | null>(null);
  const [workspaceFetcher, workspaceIsLoading, isSuccess] =
    useFetcherWithUtils<FetcherMultiErrorResponse>();

  const tableWorkspaces = useMemo(
    () => map(organizationWorkspaces, ({ id, name }) => ({ id, name })),
    [organizationWorkspaces],
  );

  const openEntityDeletionModal = (entityId: string) => {
    setWorkspace(find(organizationWorkspaces, { id: entityId }) as WorkspaceFromStore);
    setIsConfirmDeletionModalOpen(true);
  };

  const handleDeleteWorkspace = () => {
    const formData = new FormData();
    formData.append('type', 'workspace');
    formData.append('workspaceId', workspace?.id as string);
    workspaceFetcher.submit(formData, { method: 'delete' });
  };

  useEffect(() => {
    if (isSuccess) {
      setIsConfirmDeletionModalOpen(false);
    }
  }, [isSuccess]);

  return (
    <>
      <section className={s.userOptionsContaienr}>
        <Subtitle className={s.userOptionsTitle}>Organization Workspaces</Subtitle>
      </section>
      <WorkspacesTable
        workspaces={tableWorkspaces}
        openWorkspaceDeletionModal={openEntityDeletionModal}
      />
      <ConfirmDeletionModal
        title={`Delete workspace`}
        isLoading={workspaceIsLoading}
        onConfirm={handleDeleteWorkspace}
        message={`Are you sure you want to delete workspace with name ${workspace?.name}? This action cannot be reverted.`}
        isOpen={isConfirmDeletionModalOpen}
        setClose={() => setIsConfirmDeletionModalOpen(false)}
      />
    </>
  );
}
